var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("あなたの役職は"+_vm._s(_vm.playerSelf.role.name)+"です")]),_c('Card',{attrs:{"roleId":_vm.playerSelf.roleId}}),_c('p',[_vm._v(_vm._s(_vm.firstNightActionFollowMessage))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }